module.exports = __webpack_public_path__ + "img/kkam_gallery1.3573fe71.jpg";